<template>
  <li class="accordion-item">
    <h3
      :id="`accordion-heading-${index}`"
      ref="trigger"
      class="accordion-title"
      @click="open = !open"
    >
      <button
        type="button"
        class=""
        :aria-expanded="open"
        :aria-controls="`accordion-body-${index}`"
      >
        <span>{{ title }}</span>

        <FontAwesomeIcon
          :icon="accordionIcon"
          class="h-[1em] w-[1em]"
          :class="{'open' : open}"
        />
      </button>
    </h3>

    <div
      v-show="open"
      :id="`accordion-body-${index}`"
      :aria-labelledby="`accordion-heading-${index}`"
      class="accordion-body"
    >
      <slot />
    </div>
  </li>
</template>

<script setup>
import { computed, ref } from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';

const open = ref(false);
const trigger = ref(); // The element that causes the dropdown content to show

const accordionIcon = computed(() => {
  return open.value ? faMinus : faPlus;
});

defineProps({
  index: {
    type: [Number, String],
    default: 0 || null,
  },
  title: {
    type: String,
    default: null,
  },
});
</script>
